import { render, staticRenderFns } from "./UpLoads.vue?vue&type=template&id=56571448&"
import script from "./UpLoads.vue?vue&type=script&lang=js&"
export * from "./UpLoads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports